import React, { useState } from "react";
import { Card, Dialog, DialogContent, DialogTitle, Typography, styled } from "@mui/material";
import { MetaToolTip } from "../common/MetaToolTip";
import { SolutionDiagnosticsOption, MetaArguments } from "../../views/GeneralTask/generalTask.types";
import ReportImage, { RUPTURE_SET_REPORT_DIR } from "../common/ReportImage";

interface RuptureSetImageCardProps {
  id: string;
  option: SolutionDiagnosticsOption;
  currentImage: number;
  automationTasksLength: number;
  filteredMeta: MetaArguments;
}

const StyledTitle = styled(Typography)(() => ({
  display: "flex",
  justifyContent: "center",
  fontWeight: "bold",
}));

const StyledCard = styled(Card)(() => ({
  padding: "0px",
  maxHeight: "100%",
  width: "33%",
  objectFit: "contain",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "none",
  boxShadow: "none",
}));

const RuptureSetImageCard: React.FC<RuptureSetImageCardProps> = ({
  id,
  option,
  currentImage,
  automationTasksLength,
  filteredMeta,
}: RuptureSetImageCardProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <StyledCard onClick={handleClickOpen} key={option.finalPath}>
        <ReportImage key={`${id}-${option.finalPath}`} id={id} option={option} resourceDir={RUPTURE_SET_REPORT_DIR} />
      </StyledCard>
      <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClick={handleClose} style={{ zIndex: "unset" }}>
        <DialogTitle>
          <StyledTitle>
            {currentImage + 1}&nbsp;of&nbsp;{automationTasksLength}
          </StyledTitle>
          <MetaToolTip meta={filteredMeta} />
        </DialogTitle>
        <DialogContent>
          <StyledCard key={option.finalPath} style={{ width: "100%" }}>
            <ReportImage
              key={`${id}-${option.finalPath}-dialog`}
              id={id}
              option={option}
              resourceDir={RUPTURE_SET_REPORT_DIR}
              style={{ height: "100%", width: "50%" }}
            />
          </StyledCard>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RuptureSetImageCard;
